<!-- <template>
    <div class="funfacts-area pb-75 pt-75">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="funfacts-box">
                        <div class="icon">
                            <i class="ri-download-2-line"></i>
                        </div>
                        <p>Total Experience</p>
                        <h3>9+ Years</h3>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-md-6" title="98% Job Success">
                    <div class="funfacts-box bg1">
                        <div class="icon">
                            <i class="ri-star-fill"></i>
                        </div>
                        <p>Upwork 98%</p>
                        <h3 >Success</h3>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="funfacts-box bg2">
                        <div class="icon">
                            <i class="ri-global-line"></i>
                        </div>
                        <p>Projects Developed</p>
                        <h3>500+</h3>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="funfacts-box bg3">
                        <div class="icon">
                            <i class="ri-map-pin-user-line"></i>
                        </div>
                        <p>Team Size</p>
                        <h3>100+</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template> -->
<template>
    <div class="service-experience">
        <div class="container">
            <div class="row align-items-center" style="justify-content: space-around; padding: 0px 10px;">
                <div class="col-xl-2 col-lg-2 col-sm-2 col-md-2 col-6  box-mobile">
                    <div class="features-box">
                        <div class="icon">
                            <i class="ri-star-line"></i>
                        </div>
                        <!-- <p>Total Experience</p> -->
                   <p class="number-total">10+</p>
                             <h3>Years of Innovation</h3>
                              
                        <!-- <h3>Total Experience</h3> -->

                    </div>
                </div>

  <div class="col-xl-2 col-lg-2 col-sm-2 col-md-2 col-6  box-mobile">
                    <div class="features-box">
                        <div class="icon bg3">
                            <i class="ri-draft-fill"></i>
                        </div>
                        <!-- <p>Projects Developed</p> -->
                           <p class="number-total">200+</p>
                        <h3>Projects Delivered</h3>
                      
                       
                    </div>
                </div>

                <div class="col-xl-2 col-lg-2 col-sm-2 col-md-2 col-6  box-mobile">
                    <div class="features-box">
                        <div class="icon bg2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M18.561 13.158c-1.102 0-2.135-.467-3.074-1.227l.228-1.076l.008-.042c.207-1.143.849-3.06 2.839-3.06a2.705 2.705 0 0 1 2.703 2.703a2.707 2.707 0 0 1-2.704 2.702m0-8.14c-2.539 0-4.51 1.649-5.31 4.366c-1.22-1.834-2.148-4.036-2.687-5.892H7.828v7.112a2.551 2.551 0 0 1-2.547 2.548a2.55 2.55 0 0 1-2.545-2.548V3.492H0v7.112c0 2.914 2.37 5.303 5.281 5.303c2.913 0 5.283-2.389 5.283-5.303v-1.19c.529 1.107 1.182 2.229 1.974 3.221l-1.673 7.873h2.797l1.213-5.71c1.063.679 2.285 1.109 3.686 1.109c3 0 5.439-2.452 5.439-5.45c0-3-2.439-5.439-5.439-5.439"/></svg>
                        </div>
                        <!-- <p>Success</p> -->
                               <p class="number-total">98% </p>
                        <h3>Upwork Success</h3>
                     
                    </div>
                </div>

                   <div class="col-xl-2 col-lg-2 col-sm-2 col-md-2 col-6 box-mobile3">
                    <div class="features-box">
                        <div class="icon">
                            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M18.561 13.158c-1.102 0-2.135-.467-3.074-1.227l.228-1.076l.008-.042c.207-1.143.849-3.06 2.839-3.06a2.705 2.705 0 0 1 2.703 2.703a2.707 2.707 0 0 1-2.704 2.702m0-8.14c-2.539 0-4.51 1.649-5.31 4.366c-1.22-1.834-2.148-4.036-2.687-5.892H7.828v7.112a2.551 2.551 0 0 1-2.547 2.548a2.55 2.55 0 0 1-2.545-2.548V3.492H0v7.112c0 2.914 2.37 5.303 5.281 5.303c2.913 0 5.283-2.389 5.283-5.303v-1.19c.529 1.107 1.182 2.229 1.974 3.221l-1.673 7.873h2.797l1.213-5.71c1.063.679 2.285 1.109 3.686 1.109c3 0 5.439-2.452 5.439-5.45c0-3-2.439-5.439-5.439-5.439"/></svg> -->
                       <span class="span-app">App</span>
                        </div>
                        <!-- <p>Success</p> -->
                               <p class="number-total">50+</p>
                        <h3>Mobile Apps Deployed</h3>
                     
                    </div>
                </div>
              
                <div class="col-xl-2 col-lg-2 col-sm-2 col-md-2 col-6 box-mobile4">
                    <div class="features-box">
                        <div class="icon bg4">
                            <i class="ri-team-line"></i>
                        </div>
                        <!-- <p>Team Size</p> -->
                     <p class="number-total">100+</p>
                        <h3>Skilled Experts</h3>
                   
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<style>
.service-experience {
    margin: 50px 0px;
}
.service-experience .features-box {
margin-bottom: 0px;
}
p.number-total {
    font-size: 40px;
    font-weight: 700;
    margin: 0px;
    text-align: center;
}
span.span-app {
font-size: 35px; 
font-weight: 700;
    vertical-align: middle;

}

@media screen and (max-width: 767px) {
    p.number-total {
    font-size: 22px;
    color: #fff;
    }

span.span-app {
    font-size: 22px;
}

h2.title-build-ai {
padding-bottom: 20px !important;
text-align: center;
padding-right: 15px;
}
.service-experience {
    margin: 0px 0px 20px;
}

/* new style css */

.box-mobile:nth-child(1) {
    background: linear-gradient(45.24deg, #9F5FF1 5.99%, #FF54B0 91.87%);
            padding: 10px;
}

.box-mobile:nth-child(2) {
    background: linear-gradient(44.44deg, #3F75FF 7.79%, #4ADEFF 94.18%) !important;
}

.box-mobile:nth-child(3) { 
        background: linear-gradient(44.44deg, #ED2775 7.79%, #FF7448 94.18%);
}
.box-mobile3 { 
        background: linear-gradient(44.44deg, #ED2775 7.79%, #FF7448 94.18%);
      padding: 15px 10px;
        border-radius: 5px;
        width: 48.5% !important;
         margin-top: 5px !important;
}
.box-mobile4 { 
background: linear-gradient(44.44deg, #ff4b3f 7.79%, #ffac30 94.18%);
        padding: 15px 10px;
        border-radius: 5px;
        width: 48.5% !important;
        margin-top: 5px !important;
        
}
.box-mobile3 h3{
color: #fff;
}
.box-mobile {
    width: 32% !important;
    padding: 4px !important;
    border-radius: 5px;
}
.box-mobile p, .box-mobile h3 {
    color: #fff;
}

.service-experience .features-box .icon {
margin-bottom: 0px;
background: #000;
}
.service-experience .icon {
   background: linear-gradient(279.99deg, #9f5ff196 0%, #9f5ff196 100%) !important;
    display: flex;
    align-items: center;
    justify-content: center;
}
.box-mobile {
padding: 15px 10px !important;
}
}

@media screen and (min-width: 412px) and (max-width: 430px) {
h2.title-build-ai {
padding-right: 20px;
padding-left: 20px;
}
}

</style>

<script>
export default {
    name: 'Funfacts'
}
</script>